import { theme } from '@prophecy/theme';
import { Button, Dialog, Ellipsis, ProgressBar, Stack, Text } from '@prophecy/ui-v3';
import React from 'react';

import { useImportState } from '../../useImportState';

export const ValidateDialog = () => {
  const {
    transpileGraphState: {
      clientState: {
        validate: { hasValidationStarted, isCancelling, validatePercentage = 0 }
      },
      actions: { stopValidation }
    }
  } = useImportState();

  return (
    <Dialog
      footer={null}
      onClose={stopValidation}
      size='l'
      okButton={null}
      open={hasValidationStarted || isCancelling}
      data-test-id='transpiler-validate-dialog'>
      <Stack gap={theme.spaces.x20} width='100%' alignY='center' padding={`${theme.spaces.x24} ${theme.spaces.x4}`}>
        <Text level='md' weight={theme.fontWeight.medium}>
          <Ellipsis tooltip={true}>{'Validating the selected files'}</Ellipsis>
        </Text>
        {isCancelling ? null : (
          <Text level='sm' weight={theme.fontWeight.normal} tone={theme.colors.gray500}>
            Please wait while we are working on validation.
          </Text>
        )}
        <Stack direction='horizontal' width='100%' gap={theme.spaces.x8} alignY='center' align='space-between'>
          <ProgressBar height='8px' variant={'loading'} value={validatePercentage} width='100%' />
          {validatePercentage > 0 && (
            <Text level='sm' weight={theme.fontWeight.normal} tone={theme.colors.gray500}>
              {validatePercentage}%
            </Text>
          )}
        </Stack>
      </Stack>
    </Dialog>
  );
};

export const ValidateSkipDialog = () => {
  const {
    transpileGraphState: {
      clientState: {
        validate: { hasValidation, hasValidationStarted }
      },
      actions: { handleValidateAction }
    }
  } = useImportState();
  const footer = (
    <Stack direction='horizontal' align='end' gap={theme.spaces.x16}>
      <Button
        variant='secondaryGray'
        loading={hasValidationStarted}
        onClick={() => handleValidateAction(true)}
        data-test-id='validate-dialog-validate-button'>
        Validate
      </Button>
      <Button onClick={() => handleValidateAction(false)} data-test-id='validate-dialog-skip-button'>
        Skip
      </Button>
    </Stack>
  );
  return (
    <Dialog
      closable={true}
      title='Validate entities?'
      onClose={() => handleValidateAction(undefined)}
      footer={footer}
      showCloseIcon={true}
      closeButton={null}
      okButton={null}
      open={hasValidation}
      data-test-id='validate-entities-dialog'>
      <Stack padding={`${theme.spaces.x16} 0`}>
        <Text level='sm'>Validate & parse the selected entities or skip the validation before Transpilation.</Text>
      </Stack>
    </Dialog>
  );
};
